<div class="change-order-form">
	@if (isComplexOrder) {
		<app-change-complex-order
			[order]="order"
			(closeDropdown)="onCloseDropdown()"
		/>
	} @else {
		<app-change-simple-order
			[order]="order"
			(closeDropdown)="onCloseDropdown()"
		/>
	}
</div>
